export default __webpack_public_path__ + "static/media/instagram.d2360689.svg";